<div>
  <header class="header header-2 customHeader">
    <button
      class="btn customHeaderButton"
      routerLink="home"
      routerLinkActive
      #rlaHome="routerLinkActive"
      [ngClass]="rlaHome.isActive ? 'btn-success' : 'btn-inverse'"
      [attr.aria-current]="rlaHome.isActive ? 'page' : null"
    >
      1. Demo Timeline
    </button>
    <button
      class="btn customHeaderButton"
      routerLink="view-users"
      routerLinkActive
      #rlaAllUsers="routerLinkActive"
      [ngClass]="rlaAllUsers.isActive ? 'btn-success' : 'btn-inverse'"
      [attr.aria-current]="rlaAllUsers.isActive ? 'page' : null"
    >
      2. User Directory
    </button>
    <button
      class="btn customHeaderButton"
      routerLink="control-users"
      routerLinkActive
      #rlaControlAllUsers="routerLinkActive"
      [ngClass]="rlaControlAllUsers.isActive ? 'btn-success' : 'btn-inverse'"
      [attr.aria-current]="rlaControlAllUsers.isActive ? 'page' : null"
    >
      3. Manage Users
    </button>
  </header>

  <router-outlet></router-outlet>
</div>
